















import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import openbitlab from '@/types.d';
import { values } from 'lodash';

@Component({})
export default class TwitterTimeline extends Vue {
  private loaded = false;

  mounted() {
    if (typeof window !== 'undefined' && !(window as any).twttrWidgetsLoaded) {
      const script = document.createElement('script');
      script.src = 'https://platform.twitter.com/widgets.js';
      script.setAttribute('charset', 'utf-8');
      script.async = true;
      document.head.appendChild(script);
      (window as any).twttrWidgetsLoaded = true;

      this.loaded = true;
    }
  }
}
